import { useContext } from "react";
import GlobalsContext from "../context/GlobalsContext";

export default function usePermissions() {
  const globalsContext = useContext(GlobalsContext);
  return globalsContext.permissions;
}
